/** Validate phone syntax, not whether a number is assigned or reachable. */
export function isValidPhone(value: string | null | undefined): boolean {
  if (!value) return false;
  const number = value
    .trim()
    .replace(/\s*(?:ext\.?|x|#)\s*\d{1,10}$/i, '')
    .trim();
  if (!/^\+?(?:\d+|\(\d+\))(?:[ .-]*(?:\d+|\(\d+\)))*$/.test(number)) return false;
  const digits = number.replace(/\D/g, '');
  return number.startsWith('+')
    ? digits.length >= 8 && digits.length <= 15
    : digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
}
